<template>
    <div class="cs-content">
        <div class="content-bg">
            <div class="main">
                <h3 class="add-title">
                    <i class="el-icon-plus"></i>
                    <span>{{enterTitle}}</span>
                </h3>
                <div class="base-info">
                    <div class="bug-title">{{$store.state.i18n.taskDescription[$store.state.CN_EN]}}</div>
                    <div class="form-info">
                        <div class="input-text"><span class="star">*</span>{{$store.state.i18n.taskTitle[$store.state.CN_EN]}}</div>
                        <div class="cs-input">
                            <el-input :placeholder="$store.state.i18n.enterTaskTitle[$store.state.CN_EN]" v-model="theTitle"></el-input>
                        </div>
                    </div>
                    <div class="form-info">
                        <div class="input-text"><span class="star">*</span>{{$store.state.i18n.taskDetailDescription[$store.state.CN_EN]}}</div>
                        <div class="cs-input">
                            <el-input type="textarea" :autosize="{ minRows: 3}" :placeholder="$store.state.i18n.enterTaskDetail[$store.state.CN_EN]" v-model="theContent"></el-input>
                        </div>
                    </div>

                    <div class="form-info">
                        <div class="input-text"><span class="star" style="visibility: hidden">*</span>{{$store.state.i18n.workload[$store.state.CN_EN]}}</div>
                        <div class="input-small">
                            <el-input :placeholder="$store.state.i18n.enterWorkload[$store.state.CN_EN]" v-model="hour" @keyup.native="onChangeHour"></el-input>
                            <span class="unit">{{$store.state.i18n.hour[$store.state.CN_EN]}}</span>
                        </div>
                        <span class="day" v-if="showWorkday">{{workload}} {{$store.state.i18n.workday[$store.state.CN_EN]}}</span>
                    </div>
                    <div class="bug-title">{{$store.state.i18n.addTaskInfo[$store.state.CN_EN]}}</div>
                    <div class="form-info">
                        <div class="input-text"><span class="nostar">*</span>{{$store.state.i18n.moduleUnder[$store.state.CN_EN]}}</div>
                        <div class="input-small">
                            <el-select v-model="moduleLevelOneId" filterable :placeholder="$store.state.i18n.chooseLevel1[$store.state.CN_EN]" @change="onSelectModuleLevelOne" clearable>
                                <el-option
                                        v-for="item in moduleLevelOneList"
                                        :key="item.tableId"
                                        :label="item.theName"
                                        :value="item.tableId">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="input-small">
                            <el-select v-model="moduleLevelTwoId" filterable :placeholder="$store.state.i18n.chooseLevel2[$store.state.CN_EN]" @change="onSelectModuleLevelTwo" clearable>
                                <el-option
                                        v-for="item in moduleLevelTwoList"
                                        :key="item.tableId"
                                        :label="item.theName"
                                        :value="item.tableId">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="form-info">
                        <div class="input-text"><span class="star">*</span>{{$store.state.i18n.expectedTime[$store.state.CN_EN]}}</div>
                        <div class="cs-input">
                            <el-date-picker
                                    v-model="duringTime"
                                    type="daterange"
                                    :range-separator="$store.state.i18n.to[$store.state.CN_EN]"
                                    value-format="yyyy-MM-dd"
                                    :start-placeholder="$store.state.i18n.expectedStartDate[$store.state.CN_EN]"
                                    :end-placeholder="$store.state.i18n.expectedDeadlineDate[$store.state.CN_EN]">
                            </el-date-picker>
                        </div>
                    </div>
                    <div class="form-info">
                        <div class="input-text"><span class="star">*</span>{{$store.state.i18n.owner[$store.state.CN_EN]}}</div>
                        <div class="cs-input">
                            <el-select v-model="memberIdArr" multiple filterable ref="select" @visible-change="visibleChange" default-first-option :placeholder="$store.state.i18n.multipleChooseOwner[$store.state.CN_EN]">
                                <el-option
                                        v-for="item in memberList"
                                        :key="item.memberId"
                                        :label="item.theName"
                                        :value="item.memberId">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
                <div class="up-info">
                    <!--                    <el-upload-->
                    <!--                            class="upload-demo"-->
                    <!--                            drag-->
                    <!--                            action="https://jsonplaceholder.typicode.com/posts/"-->
                    <!--                            multiple>-->
                    <!--                        <i class="el-icon-upload"></i>-->
                    <!--                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>-->
                    <!--                        <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>-->
                    <!--                    </el-upload>-->
                    <file-upload :business-type="'MissionAddOrEdit'" :project-id="projectId" :is-buy-package="isBuyPackage" :is-invalid="isInvalid" :storage-space-is-unlimited="storageSpaceIsUnlimited" :can-use-storage-space="canUseStorageSpace" @getFileInfoJsonArrStr="getFileInfoJsonArrStr" :parentFileData="fileData"></file-upload>
                </div>
                <div class="foot-btn">
                    <div class="cs-btn btn-success hover" @click="commit">{{$store.state.i18n.submitTask[$store.state.CN_EN]}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import FileUpload from "../../../components/FileUpload";
    import {
        Input,
        Select,
        Option,
        TimePicker,
        DatePicker,
        Button,
        Upload,
    } from 'element-ui';
    import globalFunctions from "../../../assets/js/common/GlobalFunction";

    Vue.use(Input)
    Vue.use(Select)
    Vue.use(Option)
    Vue.use(TimePicker)
    Vue.use(DatePicker)
    Vue.use(Button)
    Vue.use(Upload)

    export default {
        name: "MissionAdd",
        components: {
            FileUpload,
        },
        data() {
            return {
                enterType: 1, // INFO: Dechert: 2020/1/21 1代表新增     2代表更新
                enterTitle: this.$store.state.i18n.createTask[this.$store.state.CN_EN],
                tableId: undefined,
                updateEntity: undefined,
                isInitDetail: true,

                theContent: "",
                projectId: undefined,
                theTitle: "",
                workload: undefined,
                hour: undefined,
                expectStartTimeStr: undefined,
                expectEndTimeStr: undefined,
                filePath: undefined,
                moduleLevelOneId: undefined,
                moduleLevelTwoId: undefined,
                duringTime: [],

                moduleLevelOneList: [],
                moduleLevelTwoList: [],
                memberList: [],
                memberIdArr: [],
                refreshModuleList: true,
                imageInfoJsonArrStr: null,
                fileData: [],
                showWorkday: false,

                //上传文件时，存储空间校验
                isBuyPackage:null,
                isInvalid:null,
                storageSpaceIsUnlimited:null,
                canUseStorageSpace:null,
            }
        },
        mounted() {
            this.$store.commit('setEnterPageUrl', "missionList.html");
            this.$byUrlInitValue("&", this, ["projectId", "projectName", "tableId"]);
            if (this.tableId == undefined) {
                this.enterType = 1;
                this.enterTitle = this.$store.state.i18n.createTask[this.$store.state.CN_EN]
                this.isInitDetail = true
            } else {
                this.enterType = 2;
                this.enterTitle = this.$store.state.i18n.editTask[this.$store.state.CN_EN]
            }
            let searchMemberForm = this.globalFunctions.baseForm();
            searchMemberForm.projectId = this.projectId
            this.$api.defaultPost('smMissionMemberListForSelect.smhtml', searchMemberForm, (data) => {
                this.memberList = data.memberList
                this.initData()
            }, false)

            Vue.nextTick(()=>{
                //获取当前可用存储空间
                globalFunctions.getStorageSpaceCanUse(this)
                // console.info(this)
            })
        },
        methods: {
            initData() {
                let form = this.globalFunctions.baseForm()
                form.projectId = this.projectId
                form.orderByFields = "sort asc , createTimeStamp desc"
                this.$api.defaultPost('/smModuleLevelOneListForSelect.smhtml', form, jsonObj => {
                    this.moduleLevelOneList = jsonObj.moduleLevelOneList;
                    this.onSelectModuleLevelOne()
                    if (this.enterType == 2) {
                        this.initDetail()
                    }
                }, false)

            },
            initDetail() {
                let form = this.globalFunctions.baseForm()
                form.tableId = this.tableId
                this.$api.defaultPost('/smMissionDetail.smhtml', form, jsonObj => {
                    let mission = jsonObj.mission;
                    this.updateEntity = mission
                    this.theTitle = mission.theTitle
                    this.theContent = mission.theContent
                    this.workload = mission.workload
                    this.hour = Number.parseFloat(mission.workload) * 8
                    this.expectStartTimeStr = mission.expectStartTimeStr
                    this.expectEndTimeStr = mission.expectEndTimeStr
                    this.duringTime.push(mission.expectStartTimeStr)
                    this.duringTime.push(mission.expectEndTimeStr)
                    // this.duringTime[0] = mission.expectStartTimeStr
                    // this.duringTime[1] = mission.expectEndTimeStr
                    console.log('during time is ' + this.duringTime)
                    this.filePath = mission.filePath
                    this.moduleLevelOneId = mission.moduleLevelOneId
                    this.moduleLevelTwoList = mission.moduleLevelTwoList
                    this.moduleLevelTwoId = mission.moduleLevelTwoId
                    this.memberIdArr = []
                    for (let i = 0; i < mission.memberList.length; i++) {
                        let memberListElement = mission.memberList[i];
                        this.memberIdArr.push(memberListElement.memberId)
                    }
                    for (let i = 0; i < mission.imageInfoList.length; i++) {
                        let element = mission.imageInfoList[i];
                        element.fileText = element.theName
                        element.fileName = element.theName
                        element.filePath = element.imagePath
                    }
                    this.fileData = mission.imageInfoList
                    if (this.workload == undefined) {
                        this.showWorkday = false
                        this.hour = undefined
                    } else {
                        this.showWorkday = true
                    }

                })
            },
            onSelectModuleLevelOne() {
                this.moduleLevelTwoList = []
                this.moduleLevelTwoId = undefined

                if (this.moduleLevelOneId && this.moduleLevelOneId > 0) {
                    let form = this.globalFunctions.baseForm()
                    form.projectId = this.projectId
                    form.moduleLevelOneId = this.moduleLevelOneId
                    form.orderByFields = "sort asc , createTimeStamp desc"
                    this.$api.defaultPost('/smModuleLevelTwoListForSelect.smhtml', form, jsonObj => {
                        this.moduleLevelTwoList = jsonObj.moduleLevelTwoList;
                        // this.refreshModuleList = false
                        // this.moduleLevelOneId = this.updateEntity.moduleLevelOneId
                        // this.moduleLevelTwoId = this.updateEntity.moduleLevelTwoId
                        if (this.enterType == 2 && this.isInitDetail) {
                            // if (this.updateEntity) {
                            //     this.moduleLevelTwoId = this.updateEntity.moduleLevelTwoId;
                            // }
                            this.isInitDetail = false
                        }
                        // console.log(this.updateEntity)
                        // console.log('moduleLevelOneId is ' + this.moduleLevelOneId + " moduleLevelTwoId is " + this.moduleLevelTwoId)
                    })
                }

                this.memberIdArr = []
                for (let i = 0; i < this.moduleLevelOneList.length; i++) {
                    let moduleLevelOneListElement = this.moduleLevelOneList[i];
                    if (moduleLevelOneListElement.tableId == this.moduleLevelOneId) {
                        this.memberIdArr.push(moduleLevelOneListElement.memberId)
                        break
                    }
                }
            },
            onSelectModuleLevelTwo() {
                this.memberIdArr = []
                for (let i = 0; i < this.moduleLevelTwoList.length; i++) {
                    let moduleLevelTwoListElement = this.moduleLevelTwoList[i];
                    if (moduleLevelTwoListElement.tableId == this.moduleLevelTwoId) {
                        this.memberIdArr.push(moduleLevelTwoListElement.memberId)
                        break
                    }
                }
            },
            commit() {
                // this.expectStartTimeStr = timeArray[0]
                // this.expectEndTimeStr = timeArray[1]

                let form = this.globalFunctions.baseForm()
                form.projectId = this.projectId
                form.theTitle = this.theTitle
                form.theContent = this.theContent
                form.hour = this.hour
                form.expectStartTimeStr = this.duringTime[0]
                form.expectEndTimeStr = this.duringTime[1]
                form.filePath = this.filePath
                form.moduleLevelOneId = this.moduleLevelOneId
                form.moduleLevelTwoId = this.moduleLevelTwoId
                form.memberIdArr = this.memberIdArr
                if (this.enterType == 1) {
                    form.imageInfoJsonArrStr = this.imageInfoJsonArrStr
                    this.$api.defaultPost('/smMissionAdd.smhtml', form, jsonObj => {
                        window.location.href = encodeURI(`missionList.html?${this.projectId}&${this.projectName}`)
                    }, false)
                } else {
                    form.tableId = this.tableId
                    form.imageInfoJsonArrStr = (this.fileData == null || this.fileData.length == 0) ? null : JSON.stringify(this.fileData);
                    this.$api.defaultPost('/smMissionUpdate.smhtml', form, jsonObj => {
                        window.location.href = encodeURI(`missionList.html?${this.projectId}&${this.projectName}`)
                    }, false)
                }
            },
            getFileInfoJsonArrStr(val) {
                console.log('getFileInfoJsonArrStr val is ')
                console.log(val)
                this.imageInfoJsonArrStr = (val == null || val.length == 0) ? null : JSON.stringify(val);
            },
            onChangeHour() {
                if (this.hour.length > 0) {
                    this.showWorkday = true
                    this.hour = this.hour.replace(/[^\d.]/g, "");  //清除“数字”和“.”以外的字符
                    this.hour = this.hour.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
                    this.hour = this.hour.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
                    // this.hour = this.hour.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');//只能输入两个小数
                    this.hour = this.hour.replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3');//只能输入两个小数
                    if (this.hour.indexOf(".") < 0 && this.hour != "") {//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
                        this.hour = parseFloat(this.hour);
                    }
                    this.workload = Number.parseFloat(this.hour) / 8
                } else {
                    this.workload = undefined
                    this.showWorkday = false
                }

            },
            //用户在下拉选展开时，输入回车默认选中第一条数据
            visibleChange(visible) {
                if (visible && this.$refs.select.hoverIndex < 0) {
                    this.$refs.select.hoverIndex = 0
                }
            },
        }
    }
</script>
<style scoped>
    .content-bg {
        text-align: center;
        padding: 20px;
        min-height: 90vh;
    }

    .main {
        display: inline-block;
        text-align: left;
    }

    .base-info {
        width: 900px;
        display: inline-block;
    }

    .up-info {
        width: 300px;
        display: inline-block;
        vertical-align: top;
        padding: 70px 0 0 40px;
    }

    .add-title {
        color: #1ab3a6;
        font-size: 20px;
        margin-top: 10px;
    }

    .bug-title {
        font-size: 16px;
        font-weight: 600;
        border-bottom: 1px solid #e4e4e4;
        padding: 15px 0;
    }

    .form-info {
        font-size: 15px;
        margin: 15px 0;
    }

    .star, .nostar {
        color: #ff5252;
        margin-right: 10px;
    }

    .nostar {
        opacity: 0;
    }

    .cs-input {
        width: 670px;
        display: inline-block;
        vertical-align: middle;
    }

    .input-small {
        width: 260px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 10px;
        position: relative;
    }

    .unit {
        position: absolute;
        right: 9px;
        top: 12px;
        font-size: 13px;
    }

    .day {
        color: #0789ee;
        font-size: 13px;
        vertical-align: middle;
    }

    .input-text {
        display: inline-block;
        width: 135px;
        margin: 5px 0;
    }

    .foot-btn {
        width: 900px;
        background: #fafafa;
        text-align: center;
        padding: 14px;
        margin: 15px 0 15px 0;
    }

    .cs-btn {
        margin-right: 0;
        width: 120px;
        height: 38px;
        line-height: 38px;
        padding: 0;
        font-size: 15px;
        box-sizing: border-box;
    }
</style>
<style>
    .el-select {
        width: 100%;
    }

    .el-upload-dragger, .el-upload {
        width: 100%;
    }

    .cs-input .el-date-editor--daterange.el-input__inner {
        width: 530px;
    }
</style>
